import { Branded }	from "ts-base/branded";

export type Permission	= Branded<string, "Permission">;
export const Permission	= {
	brand:	Branded.brand<Permission>,
};
